import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/constants";

export default function WhatsAppFab() {
    return (
        <a
            href={waLink()}
            target="_blank"
            rel="noreferrer"
            aria-label="Chat on WhatsApp"
            data-testid="whatsapp-fab"
            className="fixed z-40 bottom-5 right-5 sm:bottom-8 sm:right-8 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.35)] hover:bg-[#1EBE5A] transition-colors"
        >
            <MessageCircle className="w-6 h-6" />
            <span className="absolute inset-0 rounded-full ring-4 ring-[#25D366]/30 animate-ping" />
        </a>
    );
}
